<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="700px"
    :title="$l('dialog_title_import_order') || '导入订单'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <div v-if="visible">
      <el-form
        ref="form"
        size="small"
        class="mb-2"
        :rules="rules"
        :model="formData"
        label-position="top"
        label-width="100px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_so_salesChannel') || '销售渠道'"
              prop="platformCode"
            >
              <dict-select
                v-model="formData.platformCode"
                url="/ecomorder/ecom/platform/order/platform/select"
                :placeholder="
                  $l('tips_select_platform_code_placeholder') ||
                    '请选择销售渠道'
                "
                filterable
                size="mini"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_so_general') || '是否使用通用格式导入'"
              prop="general"
            >
              <el-checkbox-group v-model="formData.general" size="small">
                <el-checkbox label="Y">{{
                  $l('checkbox_label_use') || '使用'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="mt-2">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_io_file') || '订单文件'">
              <el-upload
                drag
                action="#"
                :file-list="listFile"
                :auto-upload="false"
                :on-change="onFileChange"
                :on-remove="() => (listFile = [])"
                accept=".csv,.CSV"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  {{
                    $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
                  }}
                  <em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        general: '',
      },
      tableData: [],
      listFile: [],
      loading: false,
      rules: {
        platformCode: [
          {
            required: true,
            message:
              this.$l('form_so_pl_title_platformCode') || '请选择销售渠道',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async confirm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (!this.listFile || this.listFile.length < 1) {
        this.$message.warning(
          this.$l('tips_warning_select_file') || '请选择导入文件'
        )
        return
      }
      this.$emit('confirm', {
        ...this.formData,
        file: this.listFile[0].raw,
      })
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    onFileChange(file) {
      this.listFile = [file]
    },
  },
}
</script>
